/**
 * 사업 접수서 — 서버 `modules/intake/intake-form.ts` 의 IntakeForm 과 같다(2026-10-22).
 * 칸 번호는 접수서 1~8. 원문에 없는 값은 null 이고 화면 · Word 는 「확인 필요」로 보인다
 */
export const INTAKE_SOURCES = ['나라장터', '나라장터 외 공고', '홈페이지', '메일', '전화', '직접'] as const;
export const BIZ_TYPES = ['입찰', '수의계약', '민간 컨설팅', '단순 문의'] as const;

export interface IntakeForm {
  receivedAt: string;
  source: (typeof INTAKE_SOURCES)[number] | null;
  receivedBy: string;
  clientOrg: string | null;
  clientDept: string | null;
  contactName: string | null;
  contactPhone: string | null;
  contactEmail: string | null;
  bizName: string | null;
  noticeNo: string | null;
  bizType: (typeof BIZ_TYPES)[number] | null;
  period: string | null;
  budget: string | null;
  dueAt: string | null;
  submitMethod: string | null;
  background: string | null;
  scope: string | null;
  deliverables: string | null;
  qualification: string | null;
  trackRecord: string | null;
  guarantee: string | null;
  documents: string[];
  files: { name: string; url: string | null }[];
  unknowns: string[];
  memo: string | null;
  next: string | null;
  /** 드라이브에 올린 최근 접수서 Word — 서버가 채운다 */
  docUrl: string | null;
}

export const emptyIntake = (receivedBy = ''): IntakeForm => ({
  receivedAt: new Intl.DateTimeFormat('sv-SE', { timeZone: 'Asia/Seoul' }).format(new Date()),
  source: '직접', receivedBy,
  clientOrg: null, clientDept: null, contactName: null, contactPhone: null, contactEmail: null,
  bizName: null, noticeNo: null, bizType: null, period: null, budget: null, dueAt: null, submitMethod: null,
  background: null, scope: null, deliverables: null, qualification: null, trackRecord: null, guarantee: null,
  documents: [], files: [], unknowns: [], memo: null, next: null, docUrl: null,
});

export interface IntakeReadResult {
  form: IntakeForm;
  read: { name: string; status: string; chars: number }[];
  model: string;
}
